import React from 'react'
import { addDays } from 'date-fns'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Icon,
  Text,
  SimpleGrid,
  FormControl,
  FormLabel
} from '@chakra-ui/react'
import { CustomDatePicker, Search, SquareButton, Select, Select2 } from '../UI'
import { ReplayIcon } from '../Icons'
import { GetStatus, GradesCarabineros } from '../../Utils'
import ExportPartners from './ExportPartners'

const FiltersPartners = ({
  filtersPartners,
  setFiltersPartners,
  initialFiltersPartners,
  children
}) => {
  const change = (key, value) =>
    setFiltersPartners({ ...filtersPartners, [key]: value })
  return (
    <Box minW={0}>
      <Flex
        gap={3}
        align={{ base: 'stretch', md: 'center' }}
        wrap="wrap"
        mb={2}
      >
        <Box flex="1 1 220px" minW={0}>
          <Search
            onChange={(e) => change('search', e.target.value)}
            currentValue={filtersPartners.search}
            showBtn={false}
          />
        </Box>
        {children}
      </Flex>
      <Accordion allowToggle>
        <AccordionItem border={0}>
          <AccordionButton px={0} py={2} _hover={{ bg: 'beige.50' }}>
            <Text flex={1} textAlign="left" fontWeight="bold" color="green.500">
              Filtros
            </Text>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel px={0} pt={2} pb={3}>
            <SimpleGrid
              columns={{ base: 1, sm: 2, xl: 3 }}
              spacing={3}
              sx={{
                '& > div': { minWidth: 0 },
                '.react-datepicker-wrapper, .react-datepicker__input-container':
                  { width: '100%', minWidth: 0 }
              }}
            >
              <FormControl>
                <FormLabel fontSize="sm" color="green.500">
                  Fecha desde
                </FormLabel>
                <CustomDatePicker
                  placeholder="DD/MM/AAAA"
                  currentDate={filtersPartners.startDate}
                  onChange={(date) => change('startDate', date)}
                  maxDate={addDays(new Date(), 0)}
                />
              </FormControl>
              <FormControl>
                <FormLabel fontSize="sm" color="green.500">
                  Fecha hasta
                </FormLabel>
                <CustomDatePicker
                  placeholder="DD/MM/AAAA"
                  currentDate={filtersPartners.endDate}
                  onChange={(date) => change('endDate', date)}
                  maxDate={addDays(new Date(), 1)}
                />
              </FormControl>
              <FormControl>
                <FormLabel fontSize="sm" color="green.500">
                  Grado
                </FormLabel>
                <Select
                  list={['Todos los Grados', ...GradesCarabineros]}
                  onChange={(grade) => change('grade', grade)}
                  value={filtersPartners.grade}
                />
              </FormControl>
              <FormControl>
                <FormLabel fontSize="sm" color="green.500">
                  Estado
                </FormLabel>
                <Select2
                  list={GetStatus.partner}
                  onChange={(state) => change('state', state)}
                  value={filtersPartners.state}
                />
              </FormControl>
              <FormControl>
                <FormLabel fontSize="sm" color="green.500">
                  Creados manualmente
                </FormLabel>
                <Select2
                  list={GetStatus.partnerCreationType}
                  onChange={(value) => change('partnerCreationType', value)}
                  value={filtersPartners.partnerCreationType}
                />
              </FormControl>
              <Flex gap={2} align="end" flexWrap="wrap">
                <SquareButton
                  aria-label="Limpiar filtros"
                  onClick={() => setFiltersPartners(initialFiltersPartners)}
                >
                  <Icon as={ReplayIcon} />
                </SquareButton>
                <ExportPartners filtersPartners={filtersPartners} />
              </Flex>
            </SimpleGrid>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Box>
  )
}
export default FiltersPartners
